import React from "react";
import "../CSS/Section.css";
import TypeAnimation from "react-type-animation";
import ibtisam__logo from '../images/ibtisam.png';
import down__arrow from '../images/down-arrow.png';
import down_animation_arrow from '../images/arrow-down.png';
function Section() {
  return (
    <div>
    <div className="section__container bg-[#f5df4e] flex flex-col md:flex-row md:justify-around items-center pt-[2rem] pb[2rem]">
      <div className="left__section w-[40%] md:pl-[60px] md:pr-[60px] text-[3rem] uk-animation-slide-left">
        <h1 className="left__section__h1">hi,i'm ibtisam</h1>
        <TypeAnimation
        className="animation__text font-[700]"
          cursor={true}
          sequence={[
            "REACT",
            2000,
            "J-SCRIPT",
            2000,
            "DEVELOPER"
          ]}
          wrapper="h1"
          repeat={Infinity}
        />
      <p className="text-2xl pt-6 pb-6"> based in Lahore, PAKISTAN.</p>
      <div className="section__buttons  w-[100%]  mb-[3rem] flex justify-center xl:justify-start text-[1rem]">
          <button className=" text-white pl-6 pr-6 pt-[12px] pb-[12px] view__work__btn">View My Works</button>
          <div className="flex justify-center items-center"><button className="font-semibold underline underline-offset-2 pl-16 pr-2">Contact Me</button><img className="cursor-pointer" src={down__arrow} width={25}/>
          </div></div>
      </div>
     <img src={ibtisam__logo} alt='ibtisam photo' className="ibtisam__logo m-auto " width={500} style={{objectPosition:'left'}}/>
    </div>
    <div className="animation_down_arrow flex justify-center pt-[2rem] pb-[2rem]">
      <img src={down_animation_arrow} width={40} className="" />
    </div>
    </div>
  );
}

export default Section;
